import { Injectable } from "@angular/core";
import { apiURL, EnvConfig } from "../../../env-config";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
import { HttpService } from "../../../http.service";
import { JWTService } from "./jwt-parser.service";
import * as _ from 'lodash';

@Injectable({
  providedIn: "root"
})
export class AuthService {

  constructor(
    private _LocalStorageService: LocalStorageService,
    private _http: HttpService,
    private _JWTService: JWTService,
    private router: Router
  ) { }

  async login(cuenta: { email: string, password: string }) {
    return new Promise((resolve, reject) => {
      let data = {
        "username": cuenta.email,
        "password": cuenta.password
      };
      this._http._post(`${apiURL(EnvConfig.API_AUTH)}/login`, data).subscribe((response) => {
        if (response.roles.length > 0) {
          if (response.roles.filter((role: any) => role.name == 'worker').length > 0) {
            return reject("Usuario no habilitado");
          }
        }
        const token = response.token;
        this._LocalStorageService.setItem('lavuro-api-token', token);
        let companies = this.profile().company;
        this._LocalStorageService.setItem('lavuro-api-company', companies);
        return resolve(token);
      }, (err) => {
        return reject(err);
      });
    });
  }

  async logout() {
    this._LocalStorageService.removeItem('lavuro-api-token');
    return Promise.resolve();
  }

  authenticated(): boolean {
    if (this.token()) return true;
    return false;
  }

  token(): string {
    const token = this._LocalStorageService.getItem('lavuro-api-token');
    if (token) return token as string;
    return '';
  }

  profile() {
    return this._JWTService.parse(this.token());
  }

  isManax() {
    try { return (this.profile().roles.filter((role: any) => role.name == 'manax')).length > 0 } catch (e) { }
    return false;
  }

  isRole(role: string) {
    try { return (this.profile().roles.filter((el: any) => el.name == role)).length > 0 } catch (e) { }
    return false;
  }

  company(): any {
    const index = this.companyIndex();
    const companies = this._LocalStorageService.getItem('lavuro-api-company');
    return _.get(companies, index);
  }

  companyId(): string {
    const index = this.companyIndex();
    const companies = this._LocalStorageService.getItem('lavuro-api-company');
    return _.get(_.get(companies, [index]), '_id');
  }

  companyName(index: number): string {
    const companies = this._LocalStorageService.getItem('lavuro-api-company');
    return _.get(_.get(companies, index), 'name');
  }

  companyIndex(): number {
    try {
      const i = window.location.href.indexOf('/admin/');
      const str = window.location.href.substring(i + 7, i + 10);
      const match = str.match(/\d+/g);
      if (match && match[0]) return parseInt(match[0]);
      return -1;
    } catch (e) { return -1; }
  }

  currency(): string {
    return _.get(this.company(), 'currencySymbol', '$');
  }

  alignmentCurrency(): string {
    return _.get(this.company(), 'currencyAlign') || 'LEFT';
  }

  passwordRequestReset(data: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_AUTH)}/user/password/recover/${data.email}`, data);
  }

  passwordReset(id: string, data: any): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_AUTH)}/user/password/reset/${id}`, data);
  }

  sendFirstMail(data: any): Observable<any> {
    return this._http._post(`${apiURL(EnvConfig.API_TRIAL)}/first-step/email`, data);
  }

  trialRegister(data: any): Observable<any> {
    return this._http._post(`${apiURL(EnvConfig.API_TRIAL)}`, data);
  }
}